import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import { HowItWorks, Testimonials, FAQ, FinalCTA } from "@/components/Sections";
import { Check } from "lucide-react";

const BENEFITS = [
  "No obligation to sell",
  "Tell us about your property",
  "Explore different selling options",
];

export default function Landing() {
  return (
    <div className="App min-h-screen bg-cream" data-testid="landing-page">
      <Header />
      <Hero />
      <EditorialMarquee />

      <section id="start" className="max-w-[1180px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="start-section">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28">
            <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold">Get started</span>
            <h2 className="font-serif font-light text-5xl md:text-6xl tracking-tight text-ink mt-6 leading-[0.95]">
              It only takes <span className="italic text-gold">60 seconds</span>
            </h2>
            <p className="text-ink-soft text-base md:text-lg mt-6 max-w-md leading-relaxed">
              Share a few details about your home. There's no obligation, and you'll simply see what options may be available to you.
            </p>
            <ul className="mt-10 space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-4 text-ink">
                  <span className="w-6 h-6 rounded-full bg-gold/15 flex items-center justify-center shrink-0">
                    <Check size={13} className="text-gold" />
                  </span>
                  <span className="text-[15px]">{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <LeadForm />
        </div>
      </section>

      <HowItWorks />
      <Manifesto />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
